import React, { FC } from 'react'

import {
  RangeValuesFilter,
  RangeValuesProps,
} from '@new/__global/components/Filters/FiltersVariations/Range'
import { filtersLabels } from '@new/domains/bookings/screens/bookingsList/utils/labels'

import { FiltersSharedProps } from './Filters.types'

interface PriceRangeFilterProps extends FiltersSharedProps {
  initialValue?: { minPrice: string; maxPrice: string }
  onChange: (value?: { minPrice?: string; maxPrice?: string }) => void
}

export const PriceRangeFilter: FC<PriceRangeFilterProps> = ({
  initialValue,
  onChange,
  ...props
}) => {
  const handleTotalPriceChange = ({ fromRangeValue, toRangeValue }: RangeValuesProps) => {
    onChange({ minPrice: fromRangeValue, maxPrice: toRangeValue })
  }

  return (
    <RangeValuesFilter
      title={filtersLabels.totalPrice}
      fromInputTypeIndicator="Min"
      toInputTypeIndicator="Max"
      shouldDisplayFiltersOnSameLine
      onChange={handleTotalPriceChange}
      rangeValues={{ fromRangeValue: initialValue?.minPrice, toRangeValue: initialValue?.maxPrice }}
      {...props}
    />
  )
}
